export const addRequestValidate = (fileData, value, facilities, place) => {

    const errors = {}

    if (!fileData.title.trim()) {
        errors.title = "لطفا عنوان را وارد کنید"
    } else {
        delete errors.title
    }

    // if (!fileData.slug.trim()) {
    //     errors.slug = "لطفا عنوان انگلیسی را وارد کنید"
    // } else {
    //     delete errors.slug
    // }

    if (!fileData.meter) {
        errors.meter = "لطفا متراژ را وارد کنید"
    } else {
        delete errors.meter
    }

    // if (fileData.startPrice === "") {
    //     errors.startPrice = "لطفا مبلغ شروع را وارد کنید"
    // } else {
    //     delete errors.startPrice
    // }

    // if (fileData.endPrice === "") {
    //     errors.endPrice = "لطفا مبلغ اتمام را وارد کنید"
    // } else {
    //     delete errors.endPrice
    // }

    // if (!facilities.find((item) => item.status === true)) {
    //     errors.facilities = "لطفا امکانات را وارد کنید"
    // } else {
    //     delete errors.facilities
    // }

    if (value === "") {
        errors.value = "لطفا نوع ملک را وارد کنید"
    } else {
        delete errors.value
    }

    // if (!fileData.description.trim()) {
    //     errors.description = "لطفا توضیحات را وارد کنید"
    // } else {
    //     delete errors.description
    // }

    if (fileData.city == "") {
        errors.city = "لطفا شهر را انتخاب کنید"
    } else {
        delete errors.city
    }

    if (place == "") {
        errors.place = "لطفا منطقه را انتخاب کنید"
    } else {
        delete errors.place
    }

    if (fileData.year == "") {
        errors.year = "لطفا سال ساخت را انتخاب کنید"
    } else {
        delete errors.year
    }

    // if (fileData.room == "") {
    //     errors.room = "لطفا تعداد اتاق را انتخاب کنید"
    // } else {
    //     delete errors.room
    // }

    // if (fileData.floor == "") {
    //     errors.floor = "لطفا طبقه را انتخاب کنید"
    // } else {
    //     delete errors.floor
    // }

    return errors;
}